import $ from "jquery";
import PopoverForm from "./util/popover_form";

$(document).on("turbolinks:load", function () {
  // (BS5): the save/download-search popovers are driven end-to-end by
  // data_hub/filter_groups.js (click → AJAX load → setContent → show, with its
  // own inserted/shown handlers). PopoverForm was a SECOND, redundant driver on
  // the same two buttons; under BS5 its seeded `content:" "` and parent-find
  // (broken under container:'body') only got in the way. Excluded here so
  // filter_groups owns them. (These were PopoverForm's only consumers.)
  $("[data-bs-toggle=popover][data-content-url]:not(.add-to-slide-deck):not(.save-search-submit):not(.download-search-submit)").each(function (i, e) {
    new PopoverForm(e);
  });
});
